import { RouterManager } from '@aclass/admin/managers';
import { CampaignStory } from '@aclass/admin/storage/actions';
import { IAdminState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class CampaignEditStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:campaign-edit';

    private id: number;

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<number | null>(['campaignModule', 'editPageRecordId']).pipe(filter(v => v === this.id));
        this.employee = this.routerManager.onRejectNavigation(CampaignEditStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        this.id = parseInt(route.params.id);
        this.ngRdx.dispatch(CampaignStory.dryRunEditPage(this.id));
    }
}
